<!-- <button class="btn-danger btn" (click)="showError()">DEBUG</button> -->

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ error.title }}
      <span (click)="showError()">
        <i *ngIf="error.type == 0" class="fas fa-bomb"></i>
        <i
          *ngIf="error.type == 1"
          class="fas fa-exclamation-triangle text-warning"
        ></i>
        <i
          *ngIf="error.type == 2"
          class="fas fa-exclamation-triangle text-warning"
        ></i>
        <i *ngIf="error.type == 3" class="far fa-angry text-danger"></i>
        <i
          *ngIf="error.type == 4"
          class="far fa-grin-beam-sweat text-danger"
        ></i>
      </span>
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div #modalBody class="modal-body" (click)="copyError(modalBody)">
    <!-- Traceback -->
    <div *ngIf="error.type == 0" class="container">
      {{ error.msg }}
    </div>

    <!-- System -->
    <div *ngIf="error.type == 1" class="container">
      {{ error.msg }}
    </div>

    <!-- Django -->
    <div *ngIf="error.type == 2" class="container">
      <i class="fas fa-bug spin-deg"></i>
      {{ error.msg }}
      <i class="fas fa-bug spin"></i>
    </div>

    <!-- 502 -->
    <div *ngIf="error.type == 3" class="container">
      {{ error.msg }}
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-outline-secondary"
      (click)="modal.close(reopenCreateModal())"
    >
    Fechar
    </button>
  </div>
</ng-template>
